

class HasilTappingMakananEntity {
  id_card?: string;
  nama?: string;
  status?: "ACCEPT" | "REJECT" | "READY" | "UNAVAILABLE" | "DOUBLE" ;
  message?: string;

  constructor(object: {
    id_card?: string;
    nama?: string;
    status?: "ACCEPT" | "REJECT" | "READY" | "UNAVAILABLE" | "DOUBLE" ;
    message?: string;
  }) {
    this.id_card = object.id_card;
    this.nama = object.nama;
    this.status = object.status;
    this.message = object.message;
  }
}

class AddTappingMakananEntity {
  id_vendor_porsi?: number;
  id_vendor?: number;
  vendor?: string;
  tanggal?: Date;
  shift?: number;
  id_lokasi?: number;
  lokasi?: string;
  tipe_makanan?: "VEGETARIAN" | "REGULAR";

  constructor(object: {
    id_vendor_porsi?: number;
    id_vendor?: number;
    vendor?: string;
    tanggal?: Date;
    shift?: number;
    lokasi?: string;
    id_lokasi?: number;
    tipe_makanan?: "VEGETARIAN" | "REGULAR";
  }) {
    this.id_vendor_porsi = object.id_vendor_porsi;
    this.id_vendor = object.id_vendor;
    this.vendor = object.vendor;
    this.tanggal = object.tanggal;
    this.shift = object.shift;
    this.id_lokasi = object.id_lokasi;
    this.lokasi = object.lokasi;
    this.tipe_makanan = object.tipe_makanan;
  }
}


export { AddTappingMakananEntity, HasilTappingMakananEntity };